import { __rest } from 'tslib';
import { t } from './i18n.es.js';
import React from 'react';
import { LazyImage } from '@teko/ui';
import { F as Flex } from './Flex-62aaa603.js';
import { T as Text } from './Text-f8e12e2a.js';

var emptyImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";

const EmptyState = (_a) => {
    var { text } = _a, props = __rest(_a, ["text"]);
    return (React.createElement(Flex, Object.assign({}, props, { flexDirection: "column", justifyContent: "center", alignItems: "center" }),
        React.createElement(LazyImage, { height: 128, width: 128, src: emptyImage }),
        React.createElement(Text, { fontSize: 12, color: "#848788", marginTop: "24px", paddingX: "2rem" }, text || t('Không tìm thấy dữ liệu'))));
};

export { EmptyState as E };
